import React, { useState, useRef, useEffect } from 'react';
import { Link, useNavigate, useLocation } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import './FloatingAdminButton.css';

const FloatingAdminButton = () => {
    const [isOpen, setIsOpen] = useState(false);
    const buttonRef = useRef(null);
    const menuRef = useRef(null);
    const { isAuthenticated, user, logout } = useAuth();
    const navigate = useNavigate();
    const location = useLocation();

    // Close menu when clicking outside
    useEffect(() => {
        const handleClickOutside = (event) => {
            if (
                buttonRef.current &&
                menuRef.current &&
                !buttonRef.current.contains(event.target) &&
                !menuRef.current.contains(event.target)
            ) {
                setIsOpen(false);
            }
        };

        if (isOpen) {
            document.addEventListener('mousedown', handleClickOutside);
        }

        return () => {
            document.removeEventListener('mousedown', handleClickOutside);
        };
    }, [isOpen]);

    // Close menu on route change
    useEffect(() => {
        setIsOpen(false);
    }, [location.pathname]);

    if (!isAuthenticated) {
        return null;
    }

    const handleLogout = () => {
        logout();
        setIsOpen(false);
        navigate('/');
    };

    return (
        <div className="floating-admin-container">
            <button
                ref={buttonRef}
                className={`floating-admin-button ${isOpen ? 'open' : ''}`}
                onClick={() => setIsOpen(!isOpen)}
                onMouseEnter={() => setIsOpen(true)}
                aria-label="管理員選單"
                aria-expanded={isOpen}
            >
                <i className="fas fa-user-circle"></i>
                <span className="floating-admin-username">{user?.username}</span>
            </button>
            
            {isOpen && (
                <div
                    ref={menuRef}
                    className="floating-admin-menu"
                    onMouseEnter={() => setIsOpen(true)}
                    onMouseLeave={() => setIsOpen(false)}
                >
                    <Link
                        to="/user-contacts"
                        className="floating-admin-menu-item floating-admin-menu-item-info"
                        onClick={() => setIsOpen(false)}
                    >
                        <i className="fas fa-address-book"></i>
                        <span>用戶聯絡</span>
                    </Link>
                    <Link
                        to="/resource-manager"
                        className="floating-admin-menu-item floating-admin-menu-item-primary"
                        onClick={() => setIsOpen(false)}
                    >
                        <i className="fas fa-folder-open"></i>
                        <span>資源管理</span>
                    </Link>
                    <Link
                        to="/admin"
                        className="floating-admin-menu-item floating-admin-menu-item-success"
                        onClick={() => setIsOpen(false)}
                    >
                        <i className="fas fa-cog"></i>
                        <span>管理員</span>
                    </Link>
                    <button
                        className="floating-admin-menu-item floating-admin-menu-item-warning"
                        onClick={handleLogout}
                    >
                        <i className="fas fa-sign-out-alt"></i>
                        <span>登出</span>
                    </button>
                </div>
            )}
        </div>
    );
};

export default FloatingAdminButton;

